<template>
  <div class="ap-field">
    <label>{{ label }} <span v-if="required" class="ap-req">*</span></label>
    <div class="ap-tax-wrap" ref="taxWrap">

      <!-- Type selector button -->
      <button type="button" class="ap-tax-type-btn" @click.stop="toggleDropdown">
        <span class="ap-tax-type-val">{{ selectedType }}</span>
        <fa-icon :icon="['fas', 'chevron-down']" class="ap-tax-chevron" :class="{ open: dropdownOpen }" />
      </button>

      <span class="ap-tax-sep"></span>

      <!-- Number input -->
      <input
        :value="localNumber"
        type="tel"
        :placeholder="placeholder"
        class="ap-tax-num"
        @input="onNumberInput"
      />

      <!-- Dropdown — fixed position to escape any parent overflow clipping -->
      <div
        v-if="dropdownOpen"
        ref="dropdown"
        class="ap-tax-dropdown"
        :style="dropdownFixedStyle"
        @click.stop
      >
        <button
          v-for="type in TAX_TYPES"
          :key="type"
          type="button"
          class="ap-tax-opt"
          :class="{ active: type === selectedType }"
          @click="selectType(type)"
        >
          {{ type }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const TAX_TYPES = ['C', 'PT', 'IG', 'P']

export default {
  name: 'TaxInput',
  props: {
    value: { type: [Object, String], default: null },
    label: { type: String, default: 'Tax Number' },
    required: { type: Boolean, default: false },
    placeholder: { type: String, default: 'e.g. 12345678' }
  },
  data () {
    return {
      TAX_TYPES,
      selectedType: TAX_TYPES[0],
      localNumber: '',
      dropdownOpen: false,
      dropdownPos: { top: 0, left: 0, width: 160 }
    }
  },
  computed: {
    dropdownFixedStyle () {
      return {
        position: 'fixed',
        top: this.dropdownPos.top + 'px',
        left: this.dropdownPos.left + 'px',
        width: this.dropdownPos.width + 'px'
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (!val) { this.localNumber = ''; return }
        if (typeof val === 'object') {
          this.selectedType = val.group || TAX_TYPES[0]
          this.localNumber = val.number || ''
          return
        }
        if (val === this.selectedType + this.localNumber) return
        this.parseValue(val)
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.onOutsideClick)
    window.addEventListener('scroll', this.closeDropdown, true)
    window.addEventListener('resize', this.closeDropdown)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onOutsideClick)
    window.removeEventListener('scroll', this.closeDropdown, true)
    window.removeEventListener('resize', this.closeDropdown)
  },
  methods: {
    parseValue (val) {
      const str = (val || '').trim()
      // Check longest prefix first (PT, IG before C, P)
      for (const type of ['PT', 'IG', 'C', 'P']) {
        if (str.toUpperCase().startsWith(type)) {
          this.selectedType = type
          this.localNumber = str.slice(type.length).replace(/\D/g, '')
          return
        }
      }
      this.localNumber = str.replace(/\D/g, '')
    },
    onNumberInput (e) {
      this.localNumber = e.target.value.replace(/\D/g, '')
      this.$emit('input', { group: this.selectedType, number: this.localNumber })
    },
    selectType (type) {
      this.selectedType = type
      this.dropdownOpen = false
      this.$emit('input', { group: this.selectedType, number: this.localNumber })
    },
    toggleDropdown () {
      if (!this.dropdownOpen) {
        const rect = this.$refs.taxWrap.getBoundingClientRect()
        this.dropdownPos = {
          top: rect.bottom + 6,
          left: rect.left,
          width: Math.max(160, rect.width)
        }
      }
      this.dropdownOpen = !this.dropdownOpen
    },
    closeDropdown (e) {
      if (e && this.$refs.dropdown && this.$refs.dropdown.contains(e.target)) return
      this.dropdownOpen = false
    },
    onOutsideClick (e) {
      if (this.$refs.taxWrap && !this.$refs.taxWrap.contains(e.target)) {
        this.dropdownOpen = false
      }
    }
  }
}
</script>
